<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="1024px"
      :fullscreen="isMobileBreakpoint"
      :persistent="isMobileBreakpoint"
    >
      <v-card class="pb-6">
        <v-toolbar class="ml-3" elevation="0" color="background">
          <div class="body-bold-medium pl-1">Testar</div>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="py-0">
          <div>
            <v-tabs
              v-model="activeTab"
              class="playr-tabs pl-2"
              align-tabs="start"
              fixed-tabs
              @change="saveActiveTab"
            >
              <v-tab>Chat no Player</v-tab>
              <v-tab>Embed</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <portal-target name="test-chat" multiple></portal-target>
              </v-tab-item>
              <v-tab-item>
                <portal-target name="test-embed" multiple></portal-target>
              </v-tab-item>
            </v-tabs-items>
          </div>

          <portal to="test-embed">
            <v-row
              style="height: 600px"
              class="chatPreview rounded-lg"
              v-if="assistant.videos"
            >
              <v-col cols="12">
                <div>
                  <iframe
                    id="assistChatIframe"
                    :src="linkEmbed"
                    style="
                      position: fixed;
                      border: none;
                      top: 75.7%;
                      left: 50%;
                      transform: translate(-50%, 50%);
                      z-index: 9999;
                      height: 50px;
                    "
                    allow="clipboard-write"
                  ></iframe>
                </div>
              </v-col>
            </v-row>
          </portal>
          <portal to="test-chat">
            <v-row>
              <v-col cols="12">
                <div
                  style="position: relative; padding-top: 56.25%"
                  v-if="assistant.videos"
                >
                  <iframe
                    id="panda-ca4862d6-384b-4f10-9a39-1e007b517ed7"
                    :src="`https://player-${assistant.pullzone_name}${
                      isStaging ? '.stg' : ''
                    }.tv.pandavideo.com.br/embed/?v=${
                      assistant.videos[0].video_external_id
                    }`"
                    style="
                      border-radius: 8px;
                      border: none;
                      position: absolute;
                      top: 0;
                      left: 0;
                    "
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
                    allowfullscreen="true"
                    width="100%"
                    height="100%"
                    fetchpriority="high"
                  ></iframe>
                </div>
              </v-col>
            </v-row>
          </portal>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script></script>
<script>
import { mapActions, mapMutations } from 'vuex'
import i18n from '@/translations/lang'
// import videosApi from '@/services/videosApi'
import { mapState } from 'vuex'

export default {
  name: 'TestModalAgent',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    video: {
      name: '',
    },
    edit: false,
    videoId: '',
    valid: false,
    isInitialized: false,
    internalTab: null,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    isStaging() {
      return !!window.location.host.match(/stg.dashboard|localhost/)
    },
    linkEmbed() {
      if (this.assistant.videos) {
        return `https://player-${this.assistant.pullzone_name}${
          this.isStaging ? '.stg' : ''
        }.tv.pandavideo.com.br/embed/assist_chat.html?v=${
          this.assistant.videos[0]?.video_external_id
        }&embed=true`
      }
      return ''
    },
    playerSettingsArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/customize-player-settings-default-1dvsqlw/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/personalizar-configuraciones-del-player-predeterminado-o2xfbx/'
      }
      return 'https://help.pandavideo.com/pt-br/article/personalizar-configuracoes-do-player-padrao-1r4o24y/'
    },
    activeTab: {
      get() {
        return this.internalTab ?? this.$route.query.tab ?? 0
      },
      set(val) {
        this.internalTab = val
      },
    },
  },
  watch: {
    open(val) {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
      if (val === false) this.$root.$emit('TestModalAgentHasClosed')
    },
  },
  props: {
    assistant: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  mounted() {
    this.$root.$on('openTestModalAgent', () => {
      this.open = true
    })
    window.addEventListener('message', (e) => {
      const chat = document.getElementById('assistChatIframe')
      'toggleOpen' === e.data &&
        ((chat.style.height = '500px'), (chat.style.top = '-2%')),
        'toggleClose' === e.data &&
          ((chat.style.height = '50px'), (chat.style.top = '75.7%'))
    })
    if (!this.$route.query.tab) {
      this.loadActiveTab()
    }
    this.isInitialized = true
  },
  beforeDestroy() {
    this.$root.$off('testModalAgent')
    this.$root.$emit('resetIsAnyOtherModal')
    this.$root.$emit('testModalClosed')
  },
  methods: {
    ...mapActions('video', ['getVideoConfig', 'getVideoProfileId']),
    ...mapMutations('video', [
      'UPDATE_VIDEO',
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_PLAYER',
      'UPDATE_VIDEO_PROFILE_ID',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleClose() {
      this.open = null
      this.$root.$emit('testModalAgentClosed')
    },
    saveActiveTab() {
      if (this.isInitialized) {
        localStorage.setItem('activeTabAgent', this.activeTab)
      }
    },
    loadActiveTab() {
      const savedTab = localStorage.getItem('activeTabAgent')
      this.activeTab = savedTab !== null ? parseInt(savedTab, 10) : 0
    },
  },
}
</script>

<style lang="scss" scoped>
.renameVideoModalTitle {
  color: varFigma(neutral-20-dark);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 21.6px */
}
.chatPreview {
  background-color: varFigma(neutral-95-lightest);
}
.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 10;
  padding: 16px;
}
@import '@/assets/scss/_typography';
.tab-icon {
  width: 18px;
  height: 24px;
  vertical-align: middle;
  background-size: 14px;
  background-position: right;
  background-repeat: no-repeat;
}
.playr-tabs {
  &::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }
    .v-slide-group__next {
      display: none !important;
    }
    .v-slide-group__content {
      flex: 1 1 auto !important;
    }
  }
  &.v-tabs {
    padding: 0;
    &::v-deep {
      .v-tabs-bar {
        .v-tab {
          font-size: $font-size-small;
          height: 24px;
          text-transform: initial;
          letter-spacing: 0px;
          border-bottom: 2px solid transparent;
          padding: 0;
          min-width: auto;
          margin-right: $spacing-05;
          white-space: nowrap;
          justify-content: start;
          max-width: fit-content;
          margin-left: 0 !important;

          &--active {
            color: varFigma(brand-50);
            border-bottom: 2px solid varFigma(brand-50);

            &:hover {
              color: varFigma(brand-40-dark);
            }
          }

          &:not([class*='active']) {
            color: var(--v-neutral-lighten1);

            &:hover {
              color: varFigma(neutral-30-base);
              border-bottom: 2px solid varFigma(neutral-80-lighter);
            }
          }
        }
        &.v-tabs-bar--is-mobile {
          .v-tab {
            font-size: 12px;
          }
        }
      }
      & .v-tab:hover::before,
      .v-tab::before {
        opacity: 0 !important;
      }
      & .v-tab:focus::before {
        opacity: 0 !important;
      }
    }

    &::v-deep {
      &.theme--dark {
        > .v-tabs-bar {
          .v-tab {
            &--active {
              color: var(--v-brand-lighten1);
            }
          }
        }
      }

      .v-tabs-slider-wrapper {
        display: none !important;
      }
    }
  }
}
</style>
